import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import { getCurrencyParts } from '../utility/formator'
import { addShake } from '../utility/helper'
import { localsMessages } from '../utility/getTemplateData'
import AmountValidationError from './amountValidationError.js';
import * as amountUtils from './amount/amountUtils';

let messages = localsMessages('common/amount');

/*
* _getCharacterWidth
* currently only return different width for 1
* {String} character
* {Number} character width
*/
let _getCharacterWidth = function(char) {
	return char === '1' ? 20 : 31;
}


/*
* _getInputWidth
* {String} amount value
* {Number} amount input width
*/
let _getInputWidth = function(val) {

	let width = 18;
	let valueArray = val.split('');

	valueArray.forEach((item) => {
		width = width + _getCharacterWidth(item);
	});

	return width;
}

let inputResize = function() {

	let donationVal = $('[name=donationAmount]')
	let	val = donationVal.val().replace(/[^0-9]/g, '')
	let amountWidth = _getInputWidth(val);
	let parsedVal = parseFloat(val) || 0;
	let parsedValLen = parsedVal.toString().length;

	if (parsedValLen <= 3) {
		amountWidth = '106'
	} else if ((parsedValLen === 4)) {
		amountWidth = '135'
	}

	donationVal.css({ width: amountWidth });
}

class AmountComponent extends React.Component {
	constructor(props) {
		super(props);
		const [firstParts = {}] = getCurrencyParts()
		this.state = {
			amount: this.props.amount || '',
			symbol: this.props.symbol || '',
			code: this.props.code || '',
			rightSymbol: firstParts.$ !== 'symbol',
		};
	}

	componentDidMount() {
		let isEditable = this.props.isEditable
		if (!isEditable) {
			$('[name=donationAmount]').attr('readOnly', true);
		} else {
			setTimeout(() => {
				$('[name=donationAmount]').focus();
			}, 600);
		}
		inputResize();
	}

	handleFocus = (event) => {
		this.props.handleAmountFocus();
	}

	handleClick = (eventName) => {}

	handleKeyPress = (event) => {
		if (!amountUtils.isKeyAllowed(event.charCode)) {
			addShake()
			return;
		}
	}

	handleChange = (event) => {
		let val = event.target.value;

		if (!amountUtils.amountLengthValid(val)) {
			addShake();
			return;
		}

		inputResize();

		const stringValue = amountUtils.formatAmount(val);

		this.setState({ amount: stringValue });
		this.props.handleAmount(stringValue);
	}

	render() {
		const label = messages.amount && messages.amount.label || '';
		const placeholder = `0${this.props.decimalPoint}00`;
		const amount = `${this.state.amount}`.replace(
			/[.|,]/i,
			this.props.decimalPoint
		);

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 amount_holder">
				<div className="inputField" >
					<div className="money_input">
						{!this.state.rightSymbol && 	<div className="amount_currency">
														<span className="amount_currency_symbol"
															id="currencySymbol">{this.state.symbol}
														</span>
													</div>
						}
						<label htmlFor="currencyAmount" className="sr-only">{label}</label>
						<input type="text"
							name="donationAmount"
							autoComplete="off"
							id="currencyAmount"
							placeholder={placeholder}
							pattern="[0-9]*"
							value={amount}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChange}
							onClick={this.handleClick}
							onFocus={this.handleFocus}
							className="amount_number validate" />
						{this.state.rightSymbol && 	<div className="amount_currency">
														<span className="amount_currency_symbol"
															id="currencySymbol">{this.state.symbol}
														</span>
													</div>
						}
					</div>
				</div>
				<p className="text-center" id="currencyCode">{this.state.code}</p>
				{
					this.props.showValidationError &&
					<div className="vx_has-error-with-message text-center">
						<AmountValidationError
							errorString={this.props.validationErrorMessage}
							errorSourceField={'currencyAmount'}
							donationAmount={amount}
						/>
					</div>
				}
			</div>
		);
	}
}

AmountComponent.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	amount: PropTypes.string,
	symbol: PropTypes.string,
	code: PropTypes.string,
	decimalPoint: PropTypes.string,
	isEditable: PropTypes.bool,
	handleAmount: PropTypes.func,
	showValidationError: PropTypes.bool,
	validationErrorMessage: PropTypes.string,
	handleAmountFocus: PropTypes.func
};

export default AmountComponent



// WEBPACK FOOTER //
// ./components/amount.js